// extracted by mini-css-extract-plugin
export var indeterminate = "_5k-5";
export var md = "_5k-4";
export var semantic = "_5k-6";
export var sm = "_5k-3";
export var text = "_5k-7";
export var toggleInput = "_5k-0";
export var toggleSwitch = "_5k-1";
export var xs = "_5k-2";